
const Footer = () => {
    return (
        <div className="footer">
            <span style={{ marginRight: "3vw" }}>Copyright &copy; {new Date().getFullYear()}</span>
            <span style={{ marginRight: "3px" }}>Made with <span style={{ color: "red" }}>❤</span> by Dom Campese</span> 
        </div>
    )
}

export default Footer
